<div class="infobox_wrap">
    <div *ngIf="isOperator">
        <div>
            <h1>Betreiber</h1>
            <p>Sind Sie Betreiber dieses Standortes?</p>
        </div>
    </div>
</div>